import React, { useEffect, useRef, useState } from "react";
// import AuthLayout from "../../components/";
import { Helmet } from "react-helmet";
import {
  Col,
  Row,
  Typography,
  List, Layout,
  Button,
  Card, Image, Modal
} from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import {
  FaArrowRight, FaCheckCircle
} from "react-icons/fa";
import { ImageUrl } from "../../helpers/Functions";
// import router from "next/router";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [modal2Open, setModal2Open] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (modal2Open && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Autoplay failed:", error);
      });
    }
  }, [modal2Open]);
  // useEffect if user is already logged in
  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);


  const data1 = [
    {
      title: "Train customers at their own pace.",
    },
    {
      title: "Help customers succeed and earn their trust.",
    },
    {
      title: "Increase customer retention.",
    },
  ];

  const data2 = [
    {
      title: "Interactive courses made of video, pdf, SCORM, HTML, and more.",
    },
    {
      title:
        "Single Sign-On for customers to log in using company credentials.",
    },
  ];

  const data3 = [
    {
      avatar: <FaCheckCircle />,
      title: "Review Customer Performances",
    },
    {
      avatar: <FaCheckCircle />,
      title: "Review Customer Feedback And Identify Skills Gaps",
    },
    {
      avatar: <FaCheckCircle />,
      title: "Encourage Improvement With Engaging Activities",
    },
  ];

  const data4 = [
    {
      avatar: <FaCheckCircle />,
      title: "Sell Course Licenses In Bulk",
      des: "and charge organizations with a one-time payment or a subscription model.",
    },
    {
      avatar: <FaCheckCircle />,
      title: "Offer Discounts Using Coupon Codes",
      des: "Number of active Users, Enrollment date, Last-active date.",
    },
  ];

  return (
    <>
    <Helmet>
        <title>Childcare Center Management & Custodial Staff Training in NYC</title>
        <meta name="description" content="Strengthen your center with childcare management training, custodial staff training programs, and expert support for educational facilities in New York City." />
        <meta property="og:title" content="Childcare Center Management & Custodial Staff Training in NYC" />
        <meta property="og:description" content="Strengthen your center with childcare management training, custodial staff training programs, and expert support for educational facilities in New York City." />
      </Helmet>
    <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
      <section>
        <Row className="cource-banner" justify={"center"} align={"middle"}>
          <Col xs={24} md={10}>
            <div className="">
              <Row style={{ width: "100%", justifyContent: "center" }}>
                <Col xs={20} md={20} className="formWrap">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("miniImg3.png")}
                  />
                  <p className="text-p-14">LMS FOR CUSTOMER TRAINING</p>
                  <Typography.Title
                    className="fontFamily1 smallTitle"
                    style={{ color: "#fff" }}
                  >
                    {<> Boost Customer Satisfaction & Loyalty</>}
                  </Typography.Title>

                  <Typography.Text
                    className="fontFamily1 smallText"
                    style={{ color: "#fff" }}
                  >
                    Train your customers to become experts with your products,
                    using customer training software. See how WrightCo Acadmey
                    helps you create and manage training that is effective for
                    customers and efficient for your organization.
                  </Typography.Text>
                  <br />
                  <br />
                  <br />
                  {!token && (
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="whiteButton"
                      onClick={() => navigate("/signup")}
                      style={{ marginLeft: "5px" }}
                    >
                      Register Now
                    </Button>
                  )}

                  <Button
                    type="primary"
                    htmlType="submit"
                    className="loginButton"
                    // onClick={() => navigate("/about-us")}
                    onClick={() => setModal2Open(true)}
                  >
                    See The Platform <FaArrowRight />
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xs={0} sm={0} md={12}>
            <div className="" style={{ textAlign: "center" }}>
              <Row style={{ width: "100%", paddingRight: "20px" }} gutter={40}>
                <Col xs={0} sm={12} md={24}>
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-56.png")}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </section>

      <section className="bg-blue top-bottom-padding two-colum-white">
        <Row justify={"center"}>
          <Col lg={19}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[32, 32]}
              className="gutter-0"
            >
              <Col xs={24} sm={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-57.png")}
                  />
                </div>
              </Col>
              <Col xs={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("miniImg4.png")}
                  />
                  <h4>Maximize Customer Retention</h4>
                  <p className="text-p-16">
                    Increase customer satisfaction by showing customers how to
                    use your product and succeed. Customer training created &
                    managed with WrightCo Academy helps you stand out from the
                    competition.
                  </p>
                  <List
                    itemLayout="horizontal"
                    dataSource={data1}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<FaCheckCircle />}
                          title={<p>{item.title}</p>}
                        />
                      </List.Item>
                    )}
                  />
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="greenTextButton"
                    onClick={() => navigate("/pricingPlans")}
                    style={{ marginLeft: "5px" }}
                  >
                    See Pricing
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      <section className="bg-white top-bottom-padding two-colum-white">
        <Row justify={"center"}>
          <Col lg={19}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[32, 32]}
              className="gutter-0"
            >
              <Col xs={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("miniImg2.png")}
                  />
                  <h4>Train Customers On Their Time</h4>
                  <p className="text-p-16">
                    Increase the value customers get from your products, using
                    online courses that customers can go through in their own
                    time from anywhere in the world.
                  </p>
                  <List
                    itemLayout="horizontal"
                    dataSource={data2}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<FaCheckCircle />}
                          title={<p>{item.title}</p>}
                        />
                      </List.Item>
                    )}
                  />
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="greenTextButton"
                    onClick={() => navigate("/pricingPlans")}
                    style={{ marginLeft: "5px" }}
                  >
                    See Pricing
                  </Button>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-58.png")}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      <section className="bg-green top-bottom-padding">
        <Row justify={"center"} style={{ textAlign: "center" }}>
          <Col xl={10} lg={12}>
            <Image
              preview={false}
              alt={"Failed to load image"}
              src={ImageUrl("miniImg2.png")}
            />
            <h4 className="text-38 text-white">
              Strengthen Customer Relationships Online
            </h4>
            <p className="text-p-16 text-white">
              Since WrighCo.Academy keeps track of all user activity on the
              platform, you can quickly address skills gaps that customers can
              improve upon during training.
            </p>
            {!token && (
              <Button
                type="primary"
                htmlType="submit"
                className="whiteButton"
                onClick={() => navigate("/signup")}
                style={{ marginLeft: "5px" }}
              >
                Get Started
              </Button>
            )}
          </Col>
        </Row>
        <Row justify={"center"} style={{ padding: "10px 0" }}>
          <Col lg={20}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[32, 32]}
              className="gutter-0"
            >
              <Col xs={24} sm={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-59.png")}
                  />
                </div>
              </Col>
              <Col xs={24} md={10}>
                <div className="list-box">
                  <List
                    itemLayout="horizontal"
                    dataSource={data3}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <span className="list-icon">{item.avatar}</span>
                          }
                          title={<h6 className="list-h6">{item.title}</h6>}
                        />
                      </List.Item>
                    )}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      <section className="bg-gray top-bottom-padding">
        <Row
          justify={"center"}
          style={{ textAlign: "center", paddingBottom: "40px" }}
        >
          <Col xl={10} lg={12}>
            <Image
              preview={false}
              alt={"Failed to load image"}
              src={ImageUrl("miniImg4.png")}
            />
            <h4 className="text-38">
              Standardize Training For Global Companies
            </h4>
          </Col>
        </Row>
        <Row justify={"center"}>
          <Col xl={20} lg={18} md={23} xs={24}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[16, 16]}
              className="gutter-0"
            >
              <Col xs={24} sm={24} md={8}>
                <div className="multiple-choice-card">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-34.png")}
                  />
                  <h5>Webinars & Seminars</h5>
                  <p>
                    Create multiple-choice, short answer, and other style
                    quizzes that can be static or dynamic.
                  </p>
                </div>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <div className="multiple-choice-card">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-35.png")}
                  />
                  <h5>On-Demand Courses</h5>
                  <p>
                    Have learners read slides, answer questions, and participate
                    in different interactive assignments.
                  </p>
                </div>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <div className="multiple-choice-card">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-36.png")}
                  />
                  <h5>Translate WrighCo Academy</h5>
                  <p>
                    Start a discussion for learners in a classroom to answer
                    questions individually and work together.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>

      <section className="bg-green top-bottom-padding">
        <Row justify={"center"} style={{ textAlign: "center" }}>
          <Col xl={10} lg={12}>
            <Image
              preview={false}
              alt={"Failed to load image"}
              src={ImageUrl("miniImg2.png")}
            />
            <h4 className="text-38 text-white">
              Sell Training Directly On The LMS
            </h4>
            <p className="text-p-16 text-white">
              Fully customize the menus, buttons, and text sections in the LMS
              to better represent your company and training type.
            </p>
            {!token && (
              <Button
                type="primary"
                htmlType="submit"
                className="whiteButton"
                onClick={() => navigate("/signup")}
                style={{ marginLeft: "5px" }}
              >
                Get Started
              </Button>
            )}
          </Col>
        </Row>
        <Row justify={"center"} style={{ padding: "10px 0" }}>
          <Col lg={20}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[32, 32]}
              className="gutter-0"
            >
              <Col xs={24} sm={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-28.png")}
                  />
                </div>
              </Col>
              <Col xs={24} md={10}>
                <div className="list-box">
                  <List
                    itemLayout="horizontal"
                    dataSource={data4}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={
                            <span className="list-icon">{item.avatar}</span>
                          }
                          title={<h6 className="list-h6">{item.title}</h6>}
                          description={<p className="list-des">{item.des}</p>}
                        />
                      </List.Item>
                    )}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
      <Row
        className="whiteBackground"
        style={{ backgroundColor: "white", justifyContent: "center" }}
      >
        <Modal
          // title="Vertically centered modal dialog"
          centered
          open={modal2Open}
          onOk={() => setModal2Open(false)}
          onCancel={() => setModal2Open(false)}
          width={1000}
          footer={false}
        >
          <div
            style={{
              padding: "50px 20px",
            }}
          >
            <video width="auto" height="auto" ref={videoRef} controls>
              <source
                src={`https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4`}
              />
              <source src="movie.ogg" type="video/ogg" />
            </video>
          </div>
        </Modal>
        {/* <Col xs={24} md={16}>
          <div
            style={{
              padding: "50px 20px",
            }}
          >
            <video width="auto" height="auto" controls>
              <source src={`https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4`} />
              <source src="movie.ogg" type="video/ogg" />
            </video>
          </div>
        </Col> */}
        {/* <Col xs={24} md={16}>
          <div style={{ position: "relative" }}>
            <Link target="_blank" to="https://trainer.wrightcoacademy.com/signup" style={{ textAlign: "center" }}>
              <Button
                type="primary"
                htmlType="submit"
                className="loginButton"
                style={{ position: "absolute", top: "0", right: "0", left: "0", bottom: "0", margin: "auto", zIndex: "999", maxWidth: "200px" }}
              >
                Join us as a Trainer
              </Button>
            </Link>
            <Image src={ImageUrl('Trainer.jpeg')} preview={false} />
          </div>
        </Col> */}
        <Col xs={24} md={16}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",

              padding: "50px 20px",
            }}
          >
            <Card
              className="contactCard1 terms-box"
              bordered={false}
              style={{
                width: "100%",
                padding: "20px",
              }}
            >
              <h3> We’re Looking for Trainers</h3>
              <h3>Teach. Create. Earn.</h3>
              <p>
                {" "}
                Are you passionate about teaching? Ready to share your
                expertise, connect with professionals, and make a meaningful
                impact, all while earning extra income?
              </p>

              <h4> You've come to the right place.</h4>
              <p>
                {" "}
                At WrightCo Academy, we are building a network of world-class
                trainers and industry experts dedicated to developing
                high-quality courseware for professionals in early care and
                education. If you’re an expert in your field with a desire to
                teach, we’d love to have you on board!
              </p>

              <h3> Why Join Us?</h3>
              <ul>
                <li>
                  <p>
                    ✅ Expand Your Reach – Share your knowledge with a broad
                    audience of professionals.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Boost Your Visibility – Gain recognition as a trusted
                    expert in your industry.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Join a Thriving Community – Connect with like-minded
                    trainers and industry leaders.
                  </p>
                </li>
                <li>
                  <p>
                    ✅ Earn Passive Income – Our fair and flexible
                    revenue-sharing model ensures unlimited earning potential.
                  </p>
                </li>
              </ul>

              <h3> What It Takes to Be a WrightCo Trainer</h3>
              <ul>
                <li>
                  <p>
                    ✔ <strong>Passion for Teaching</strong> – A commitment to
                    sharing knowledge and empowering others.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Industry Expertise</strong> – Relevant
                    certifications and experience in your domain.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Strong Communication Skills</strong> – Ability to
                    present information effectively.
                  </p>
                </li>
                <li>
                  <p>
                    ✔ <strong>Commitment to Excellence</strong> – Willingness to
                    develop and deliver high-quality training.
                  </p>
                </li>
              </ul>
              <h4> Ready to Make an Impact?</h4>
              <p>
                {" "}
                Join WrightCo Academy today and take the next step in your
                teaching journey.
              </p>
            </Card>
          </div>
        </Col>
      </Row>

      {/* <section className="bg-white top-bottom-padding two-colum-white">
        <Row justify={"center"}>
          <Col lg={19}>
            <Row
              justify={"center"}
              align={"middle"}
              gutter={[32, 32]}
              className="gutter-0"
            >
              <Col xs={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("miniImg.png")}
                  />
                  <h4>All-In-One Platform For B2B Training</h4>
                  <p className="text-p-16">
                    WrightCo Academy connects with other software, so
                    organizations can use familiar business tools in their
                    training programs. See some examples of software you can use
                    with WrightCo Academy LMS:
                  </p>
                  <List
                    itemLayout="horizontal"
                    dataSource={data5}
                    renderItem={(item, index) => (
                      <List.Item>
                        <List.Item.Meta
                          avatar={<FaCheck />}
                          title={<p>{item.title}</p>}
                        />
                      </List.Item>
                    )}
                  />
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="greenTextButton"
                    onClick={() => navigate("/pricingPlans")}
                    style={{ marginLeft: "5px" }}
                  >
                    See Pricing
                  </Button>
                </div>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <div className="">
                  <Image
                    preview={false}
                    alt={"Failed to load image"}
                    src={ImageUrl("new-55.png")}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section> */}

      {/* <section className="bg-white top-bottom-padding">
        <Row justify={"center"}>
          <Col xl={18} lg={17} md={23} xs={23}>
            <div className="on-demand">
              <h4>Efficiently Sell Courses & Webinars Online</h4>
              <Button
                type="primary"
                htmlType="submit"
                className="whiteButton"
                onClick={() => navigate("/about-us")}
                style={{ marginLeft: "5px" }}
              >
                Get Started
              </Button>
            </div>
          </Col>
        </Row>
      </section> */}
    </Layout>
    </>
  );
}

export default Homepage;
